import logoWhiteIconHat from '~/assets/images/logo/logo-white-icon-hat.png'
import logoWhiteFullHat from '~/assets/images/logo/logo-white-full-hat.png'

export default {
  christmas: {
    id: 'christmas',
    name: 'Christmas',
    theme: 'christmas', // References the theme key in themes.js
    startDate: {
      day: 1,
      month: 12, // December
      year: null, // null = repeats every year
    },
    endDate: {
      day: 31,
      month: 12, // December
      year: null, // null = repeats every year
    },
    banner: {
      component: true, // Components in /components/holiday/christmas/Banner.vue
    },
    logo: {
      icon: logoWhiteIconHat,
      full: logoWhiteFullHat,
    },
    animation: {
      enabled: true,
      component: true, // Components in /components/holiday/christmas/Animation.vue
      menuButton: {
        component: true, // Components in /components/holiday/christmas/Button.vue
      },
    },
  },
}
